// extracted by mini-css-extract-plugin
export default {"content":"LoaderIndicator_content__W3jtw","rotate":"LoaderIndicator_rotate__bC1GM","changeColor":"LoaderIndicator_changeColor__t2wRm"};